import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import chromeExtension_1 from '../../../../../libraries/Images/chromeExtension_1.png';
import chromeExtension_2 from '../../../../../libraries/Images/chromeExtension_2.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="chromeextension">
                1. {translate('chromeextension')}
            </Typography>
            <p>This extension is a function that enables you to easily obtain a CSS selector by simply right-clicking on the location where you want to obtain the CSS selector and executing "Copy CSS Selector".</p>
            <p>The procedure:</p>
            <ol>
                <li>Go to the installation page from the link below.</li>
                <p>Open <a href='https://chrome.google.com/webstore/detail/rpa-cloud/hbbknhmpmbpeahaielmdciknifcodkdj?hl=en' target="_blank">the installation page</a>.</p>
                <li>Click [Add to Chrome]</li>
                <Zoom>
                    <img src={chromeExtension_1} width="75%" />
                </Zoom>
                <li>Click [Add extension]</li>
                <Zoom>
                    <img src={chromeExtension_2} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(En);